import axios from 'axios';

import type { GetLockboxAccessLogsResponse, JsonObject } from '@/app-package';

export type LockboxAccessLogs = JsonObject<GetLockboxAccessLogsResponse>;

const getLockboxAccessLogs = async (
  lockboxType: 'masterlock' | 'sentrilock',
  deviceId: string,
  page = 0,
  date?: Date,
) => {
  const { data } = await axios.get<LockboxAccessLogs>(`/lockbox/accesslog`, {
    params: { type: lockboxType, deviceId, page, date },
  });

  return data;
};

export default getLockboxAccessLogs;
